import { apiFetch, apiUrl, OFFLINE_MESSAGE } from "./api";

/**
 * Shared JSON fetch helper for the cookie-authed admin/user API clients
 * (support, feedback, tool requests, usage).
 *
 * This used to live in the blog API client, which every other client imported
 * for it. The blog was removed, so it lives on its own here.
 */

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function request<T>(path: string, init?: RequestInit): Promise<T> {
  let res: Response;
  try {
    res = await apiFetch(apiUrl(path), {
      credentials: "include",
      headers: { "Content-Type": "application/json", ...(init?.headers ?? {}) },
      ...init,
    });
  } catch (err) {
    if (err instanceof TypeError && /fetch/i.test(err.message)) {
      throw new ApiError(OFFLINE_MESSAGE, 0);
    }
    throw err;
  }
  if (res.status === 204) return undefined as T;
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    const message =
      (data && typeof data === "object" && "error" in data
        ? String((data as { error: unknown }).error)
        : null) ?? `Request failed (${res.status})`;
    throw new ApiError(message, res.status);
  }
  return data as T;
}
